
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { UseFormReturn } from "react-hook-form";
import type { ListingFormValues } from "./types";

interface TermsSectionProps {
  form: UseFormReturn<ListingFormValues>;
  isDisabled: boolean;
  termsError?: string | null;
}

const TermsSection = ({ form, isDisabled, termsError }: TermsSectionProps) => {
  return (
    <div className="space-y-4 border-t border-brand-cloud pt-4">
      <h2 className="public-card-title">Terms and Conditions</h2>

      <FormField
        control={form.control}
        name="terms_accepted"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-3 space-y-0">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
                disabled={isDisabled}
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel>
                I agree to the{" "}
                <a
                  href="/terms"
                  className="public-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms and Conditions
                </a>
              </FormLabel>
              <FormDescription>
                You must agree to the terms and conditions before publishing a provider listing
              </FormDescription>
              {termsError && (
                <p className="text-sm font-medium text-destructive">{termsError}</p>
              )}
            </div>
          </FormItem>
        )}
      />
    </div>
  );
};

export default TermsSection;
